import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AclService } from "./acl.service";
import { firstValueFrom } from "rxjs";
import { filter, take } from "rxjs/operators";
import { defaults } from "@assoanalytics/app/app.config";
import { AuthService } from "../services/auth.service";
import { SnackbarService } from "@assoanalytics/app/shared/services/snackbar/snackbar.service";

@Injectable({ providedIn: "root" })
export class AclGuard implements CanActivate {
  appConfig = defaults;

  constructor(
    private aclService: AclService,
    private router: Router,
    private authService: AuthService,
    private snackBarService: SnackbarService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const role = this.authService.getCurrentUser()?.role;
    const enabledRoles = this.aclService.getEnabledRoles();
    const level = this.authService.getRoleFromToken();

    if (role && enabledRoles) {
      if (!enabledRoles.includes(role)) {
        this.snackBarService.error("Utenza non abilitata all'accesso");
        this.authService.logout();
        return false;
      }
    } else {
      this.snackBarService.error("Utenza non abilitata all'accesso");
      this.authService.logout();
      return false;
    }

    // Attendi che AclService sia pronto (ready === true)
    await firstValueFrom(
      this.aclService.ready$.pipe(
        filter((ready) => ready),
        take(1),
      ),
    );

    const module = route.data["module"];
    if (this.aclService.isModuleEnabled(module)) {
      return true;
    } else {
      this.router.navigate(["/not-authorized"]);
      return false;
    }
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    // Attendi che AclService sia pronto (ready === true)
    await firstValueFrom(
      this.aclService.ready$.pipe(
        filter((ready) => ready),
        take(1),
      ),
    );

    const module = childRoute.parent?.data?.["module"];
    const aclRef = childRoute.data?.["aclRef"];

    if (!module || !aclRef) {
      console.warn("Modulo o aclRef mancante nella rotta:", childRoute);
      this.router.navigate(["/not-authorized"]);
      return false;
    }

    if (this.aclService.isChildEnabled(module, aclRef)) {
      return true;
    }

    this.router.navigate(["/not-authorized"]);
    return false;
  }
}
